const blockNamePattern = /s(\d+)_\d+_(b\d+)_/;

export function getBlockChapter(name: string) {
    const match = name.match(blockNamePattern);

    return match ? match[1] : "";
}
export function getBlockID(name: string) {
    const match = name.match(blockNamePattern);

    return match ? `${match[1]}_${match[2]}` : "";
}
export function getBlockNumber(name: string) {
    const match = name.match(blockNamePattern);

    return match ? match[2] : "";
}
